import "./Contact.css";
import React from "react";
import Mouseflow from "shared/components/Mouseflow";
import MarketingPageContent from "../components/MarketingPageContent";
import PropTypes from "prop-types";
import PropulatedView from "higher-order/PropulatedView";
import ContentItem from "shared/components/cms/ContentItem";
import ContactStore from "../models/ContactStore";
import EmployeeSignup from "../components/EmployeeSignup";

class Contact extends React.Component {
    static propTypes = {
        contactMediaEmail: PropTypes.string,
        generalSalesEmail: PropTypes.string
    };

    componentDidMount() {
        Mouseflow();
    }

    render() {
        const {
            contactMediaEmail,
            generalSalesEmail
        } = this.props;

        return (
            <MarketingPageContent>
                <img alt="background" src={require("../assets/redesign2020/contact/chevron_1.svg")} className="contact-background-image-1" />
                <img alt="background" src={require("../assets/redesign2020/contact/chevron_2.svg")} className="contact-background-image-2" />
                <div className="contact-page">
                    <h1 className="contact-header">
                        <span className="highlighted">Contact</span> us
                    </h1>
                    <div className="contact-body">
                        <h2 className="contact-header-location">LOCATION</h2>
                        <address className="contact-address">
                            <ContentItem tag="span" contentKey="address1_v2" />
                            <ContentItem tag="span" contentKey="address2_v2" />
                        </address>
                        <h2 className="contact-header-sales">GENERAL CONTACT & SALES</h2>
                        <a className="contact-sales-email" href={`mailto:${generalSalesEmail}`}>{generalSalesEmail}</a>
                        <h2 className="contact-header-media">MEDIA INQUIRIES</h2>
                        <a className="contact-media-email" href={`mailto:${contactMediaEmail}`}>{contactMediaEmail}</a>
                    </div>
                    <EmployeeSignup />
                </div>
            </MarketingPageContent>
        );
    }
}

export default PropulatedView(Contact, ContactStore, ["contactMediaEmail", "generalSalesEmail"]);